import React, { useState, useEffect } from "react";
import "./header.css";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className={`site-header ${scrolled ? "scrolled" : ""}`}>
      <div className="header-logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
        <span className="logo-ar">فيروز</span>
        <span className="logo-divider">·</span>
        <span className="logo-en">Fayrouz</span>
      </div>

      <nav className="header-nav">
        <button onClick={() => scrollTo("origins")}>Origins</button>
        <button onClick={() => scrollTo("music")}>Music</button>
        <button onClick={() => scrollTo("legacy")}>Legacy</button>
        <button onClick={() => scrollTo("songs")}>Songs</button>
        <button onClick={() => scrollTo("timeline")}>Timeline</button>
      </nav>

      <div className="header-tag">Voice of the Orient</div>
    </header>
  );
}